import React, { useRef } from "react";
import "./AiCreditConfirm.css";

/**
 * Confirmation dialog before consuming AI credits.
 * Shows action description, credit cost, remaining balance, and user identity.
 */
export default function AiCreditConfirm({ isOpen, action, credits, remainingCredits, userName, onConfirm, onCancel }) {
  const confirming = useRef(false);

  if (!isOpen) return null;

  const insufficient = remainingCredits !== null && remainingCredits !== undefined && remainingCredits < credits;

  const handleConfirm = () => {
    if (confirming.current) return; // Prevent double-click
    confirming.current = true;
    onConfirm();
    // Reset after a short delay (dialog will close via parent state)
    setTimeout(() => { confirming.current = false; }, 1000);
  };

  return (
    <div className="ai-credit-overlay" onClick={onCancel}>
      <div className="ai-credit-dialog" onClick={(e) => e.stopPropagation()}>
        <div className="ai-credit-dialog-header">
          <span className="ai-credit-dialog-icon">⚡</span>
          <h4 className="ai-credit-dialog-title">AI Credit Confirmation</h4>
        </div>

        <div className="ai-credit-dialog-body">
          {userName && (
            <div className="ai-credit-dialog-row">
              <span className="ai-credit-dialog-label">User:</span>
              <span className="ai-credit-dialog-value">{userName}</span>
            </div>
          )}
          <div className="ai-credit-dialog-row">
            <span className="ai-credit-dialog-label">Action:</span>
            <span className="ai-credit-dialog-value">{action}</span>
          </div>
          <div className="ai-credit-dialog-row">
            <span className="ai-credit-dialog-label">Credits Required:</span>
            <span className="ai-credit-dialog-value ai-credit-cost">{credits} credit{credits > 1 ? "s" : ""}</span>
          </div>
          {remainingCredits !== null && remainingCredits !== undefined && (
            <div className="ai-credit-dialog-row">
              <span className="ai-credit-dialog-label">Balance After:</span>
              <span className={`ai-credit-dialog-value ${insufficient ? "ai-credit-insufficient" : "ai-credit-sufficient"}`}>
                {insufficient ? "Insufficient" : `${remainingCredits - credits} credits remaining`}
              </span>
            </div>
          )}
        </div>

        {insufficient && (
          <div className="ai-credit-dialog-warning">
            ⚠️ Insufficient credits. Contact your admin to add more credits.
          </div>
        )}

        <div className="ai-credit-dialog-footer-note">
          This action will be logged in the audit trail.
        </div>

        <div className="ai-credit-dialog-actions">
          <button className="ai-credit-dialog-btn ai-credit-cancel" onClick={onCancel}>Cancel</button>
          <button
            className="ai-credit-dialog-btn ai-credit-confirm"
            onClick={handleConfirm}
            disabled={insufficient}
          >
            {insufficient ? "Insufficient Credits" : `Use ${credits} Credit${credits > 1 ? "s" : ""}`}
          </button>
        </div>
      </div>
    </div>
  );
}
